export const HIDE_PINFEATURE = true;
export const CALL_MODES = {
   ONETOONE: 'ONE-TO-ONE',
   ONETOMANY: 'ONE-TO-MANY',
   MEET: 'MEET',
};

export const CALL_TYPE = {
   AUDIO: 'AUDIO',
   VIDEO: 'VIDEO',
};

export const CALLKIT_CALLSTATUS = {
   RINGING: 'RINGING',
   CONNECTING: 'CONNECTING',
   CONNECTED: 'CONNECTED',
   DISCONNECTED: 'DISCONNECTED',
   REJECTED: 'REJECTED',
   ENGAGED: 'ENGAGED',
   TIMEOUT: 'TIME-OUT',
   CALLING: 'CALLING',
   TRY_TO_CONNECT: 'TRY TO CONNECT',
   RECONNECTING: 'RECONNECTING',
   ON_HOLD: 'ON_HOLD',
};

export const CALLKIT_UI_CALLSTATUS = {
   RINGING: 'Ringing',
   CONNECTING: 'Connecting',
   CONNECTED: 'Connected',
   DISCONNECTED: 'Disconnected',
   REJECTED: 'Busy',
   ENGAGED: 'Engaged',
   TIMEOUT: 'Time out',
   CALLING: 'Calling',
   'TRY TO CONNECT': 'Trying to connect',
   RECONNECTING: 'Reconnecting',
   USER_OFFLINE: 'User seems to be offline, Trying to connect',
};

export const CALLKIT_CALLSCREENSTATUS = {
   INCOMING: 'incoming',
   OUTGOING: 'outgoing',
   CONNECTED: 'connected',
   IDLE: 'idle',
   ENDED: 'ended',
};

export const CALLKIT_VIEWMODE = {
   AUTO: 'auto',
   TILED: 'tiled',
   SPOTLIGHT: 'spotlight',
   SIDEBAR: 'sidebar',
};

export const CALLKIT_CALLUISTATE = {
   HIDDEN: 'hidden',
   MAXIMIZED: 'maximized',
   MINIMIZED: 'minimized',
};

export const CALLKIT_MAXTILES = 8;
export const SOMETHING_WENT_WRONG = 'Something went wrong';
export const NOT_ABLE_TO_ANSWER = 'You are not able to answer this call';
export const NEGOTIATION_TIMED_OUT = 'negotiation timed out';
export const NOT_ABLE_TO_MUTE_AUDIO = 'You are not able to mute audio';
export const NOT_ABLE_TO_UNMUTE_AUDIO = 'You are not able to unmute audio';
export const NOT_ABLE_TO_MUTE_VIDEO = 'You are not able to mute video';
export const NOT_ABLE_TO_UNMUTE_VIDEO = 'You are not able to unmute video';
export const NO_ONGOINGCALL = 'No ongoing call found';
export const CLIENT_INITIATED_DISCONNECT = 'Client initiated disconnect';

export const CALL_SWITCH_ACCEPT = 'call_switch_accept';
export const CALL_SWITCH_DECLINE = 'call_switch_decline';
export const CALL_SWITCH_CANCEL = 'call_switch_cancel';
export const CALL_SWITCH_REQ_WAITING = 'call_switch_outgoing_request';
export const CALL_SWITCH_REQUEST_INIT = 'call_switch_request_init';
export const CALL_SWITCH_REQUEST = 'call_switch_incoming_request';
export const AUDIO_CALL_PERMISSION_DENIED_CODE = 100606;
export const VIDEO_CALL_PERMISSION_DENIED_CODE = 100607;
export const CALL_LINK_UPDTAE = 'callLinkUpdate';
export const CALL_TYPE_UPDATE = 'callTypeUpdate';
export const CALL_MODE_UPDATE = 'callModeUpdate';
export const AUDIO_CALL_PERMISSION_DENIED_MSG = "Audio permission is not granted. Couldn't process the call.";
export const VIDEO_CALL_PERMISSION_DENIED_MSG = "Video permission is not granted. Couldn't process the call.";

export const CALL_LOG_DIRECTION = {
   BACKWARD: 'backward',
   FORWARD: 'forward',
};

export const CALL_KIT_SCREENSHARE_STATE = {
   START: 'START',
   STOP: 'STOP',
   RECONNECTING: 'RECONNECTING',
};

export const CALL_PARTICIPANT_CONNECTION_QUALITY = {
   LOST: 'lost',
   POOR: 'poor',
   GOOD: 'good',
   EXCELLENT: 'excellent',
};